import React from 'react';

const fieldRowStyle = { display: 'flex', alignItems: 'flex-start', marginBottom: 6 };
const labelColumnStyle = {
  display: 'flex',
  flexDirection: 'column' as const,
  flex: '0 0 90px',
  justifyContent: 'center',
  minHeight: 30,
};
const labelStyle = { color: '#999', fontSize: '0.9rem', fontWeight: 500, lineHeight: 1.3 };

const FieldLabel = (props: { label: string, subLabel?: string, children: React.ReactNode }) : React.ReactElement => {
  return (
    <div style={fieldRowStyle}>
      <div style={labelColumnStyle}>
        <p style={labelStyle}>
          {props.label}
        </p>
        {props.subLabel && (
          <p style={labelStyle}>
            {props.subLabel}
          </p>
        )}
      </div>
      <div style={{ flex: 1 }}>
        {props.children}
      </div>
    </div>
  );
};

FieldLabel.defaultProps = { subLabel: undefined };

export default FieldLabel;
